<template>
  <div>
    <div v-if="this.graphs.length > 0">
      <br /><br />
      <div v-if="!isSensorDataEmpty(4)">
        <div class="text-center text-2xl mb-4">
          {{ $t("dashboard_section1_title") }}
        </div>
        <div class="grid grid-cols-1">
          <div class="section-content-donuts" v-if="this.aqiSensor.length > 0">
            <dashboard-donut
              v-for="donut in this.aqiSensor.filter(
                (graph) => graph.influxId == 'AQI' && graph.type == 'donut'
              )"
              v-bind:key="donut.index"
              v-bind:donut="donut"
              v-bind:nightMode="nightMode"
            />
          </div>
          <div class="section-content-donuts" v-else-if="isSensorDataEmpty(5)">
            <AQIDashboardDonut
              :hideLoader="
                graphs.some((g) => g.influxId === 'PM10') &&
                graphs.some((g) => g.influxId === 'PM2_5') &&
                graphs.some((g) => g.influxId === 'NO2') &&
                graphs.some((g) => g.influxId === 'SO2') &&
                graphs.some((g) => g.influxId === 'O3')
              "
              v-bind:donut="emptyDonut"
              v-bind:nightMode="nightMode"
            />
          </div>
        </div>
        <div class="grid grid-cols-1 lg:grid-cols-4">
          <div
            class="section-content-donuts"
            v-if="graphs.some((g) => g.influxId === 'PM2_5')"
          >
            <dashboard-donut
              v-for="donut in this.graphs.filter(
                (graph) => graph.influxId == 'PM2_5' && graph.type == 'donut'
              )"
              v-bind:key="donut.index"
              v-bind:donut="donut"
              v-bind:nightMode="nightMode"
            />
          </div>
          <div
            class="section-content-donuts"
            v-if="graphs.some((g) => g.influxId === 'PM10')"
          >
            <dashboard-donut
              v-for="donut in this.graphs.filter(
                (graph) => graph.influxId == 'PM10' && graph.type == 'donut'
              )"
              v-bind:key="donut.index"
              v-bind:donut="donut"
              v-bind:nightMode="nightMode"
            />
          </div>
          <div
            class="section-content-donuts"
            v-if="graphs.some((g) => g.influxId === 'NO2')"
          >
            <dashboard-donut
              v-for="donut in this.graphs.filter(
                (graph) => graph.influxId == 'NO2' && graph.type == 'donut'
              )"
              v-bind:key="donut.index"
              v-bind:donut="donut"
              v-bind:nightMode="nightMode"
            />
          </div>
          <div
            class="section-content-donuts"
            v-if="graphs.some((g) => g.influxId === 'SO2')"
          >
            <dashboard-donut
              v-for="donut in this.graphs.filter(
                (graph) => graph.influxId == 'SO2' && graph.type == 'donut'
              )"
              v-bind:key="donut.index"
              v-bind:donut="donut"
              v-bind:nightMode="nightMode"
            />
          </div>
          <div
            class="section-content-donuts"
            v-if="graphs.some((g) => g.influxId === 'O3')"
          >
            <dashboard-donut
              v-for="donut in this.graphs.filter(
                (graph) => graph.influxId == 'O3' && graph.type == 'donut'
              )"
              v-bind:key="donut.index"
              v-bind:donut="donut"
              v-bind:nightMode="nightMode"
            />
          </div>
        </div>
        <br /><br />
      </div>

      <div v-if="!isSensorDataEmpty(2)">
        <div class="section-header text-center">
          <hr
            :style="{
              'border-color': !nightMode ? '#fff' : '#000',
            }"
          />
          <br />
          <div class="text-center text-2xl mb-4">
            {{ $t("dashboard_section2_title") }}
          </div>
        </div>
        <div class="grid grid-cols-1 lg:grid-cols-2">
          <div
            v-if="this.graphs.some((item) => item.influxId === 'noise')"
            class="section-content-donuts"
          >
            <dashboard-donut
              v-for="donut in this.graphs.filter(
                (graph) => graph.influxId == 'noise' && graph.type == 'donut'
              )"
              v-bind:key="donut.index"
              v-bind:donut="donut"
              v-bind:nightMode="nightMode"
            />
          </div>
          <div
            v-if="this.graphs.some((item) => item.influxId === 'CO2')"
            class="section-content-donuts"
          >
            <dashboard-donut
              v-for="donut in this.graphs.filter(
                (graph) => graph.influxId == 'CO2' && graph.type == 'donut'
              )"
              v-bind:key="donut.index"
              v-bind:donut="donut"
              v-bind:nightMode="nightMode"
            />
          </div>
        </div>
        <div class="grid grid-cols-1 lg:grid-cols-2">
          <div
            v-if="this.graphs.some((item) => item.influxId === 'T')"
            class="section-content-donuts"
          >
            <dashboard-donut
              v-for="donut in this.graphs.filter(
                (graph) => graph.influxId == 'T' && graph.type == 'donut'
              )"
              v-bind:key="donut.index"
              v-bind:donut="donut"
              v-bind:nightMode="nightMode"
            />
          </div>
          <div
            v-if="this.graphs.some((item) => item.influxId === 'RH')"
            class="section-content-donuts"
          >
            <dashboard-donut
              v-for="donut in this.graphs.filter(
                (graph) => graph.influxId == 'RH' && graph.type == 'donut'
              )"
              v-bind:key="donut.index"
              v-bind:donut="donut"
              v-bind:nightMode="nightMode"
            />
          </div>
        </div>
        <br /><br />
      </div>
      <div v-if="!isSensorDataEmpty(1)">
        <div class="section-header text-center">
          <hr
            :style="{
              'border-color': !nightMode ? '#fff' : '#000',
            }"
          />
          <br />
          <div class="text-center text-2xl mb-4">
            {{ $t("dashboard_section3_title") }}
          </div>
        </div>
        <br /><br />
        <div class="grid grid-cols-1 sm:grid-cols-2">
          <div v-if="this.aqiSensor.length > 0" class="section-content-donuts">
            <LineChart
              :nightMode="nightMode"
              :data="
                this.aqiSensor.filter(
                  (graph) => graph.influxId == 'AQI' && graph.type == 'line'
                )[0]
              "
              style="padding: 10px"
            />
          </div>
          <div v-else-if="isSensorDataEmpty(5)" class="section-content-donuts">
            <FacebookLoader
              v-if="
                graphs.some((g) => g.influxId === 'PM2_5') &&
                graphs.some((g) => g.influxId === 'PM10') &&
                graphs.some((g) => g.influxId === 'NO2') &&
                graphs.some((g) => g.influxId === 'SO2') &&
                graphs.some((g) => g.influxId === 'O3')
              "
              :color="this.nightMode === true ? '#000000' : '#ffffff'"
              :size="60"
              class="my-1"
              :style="{
                position: 'relative',
                top: $isMobile() ? '48%' : '36%',
                left: $isMobile() ? '49%' : '50%',
              }"
            />
            <LineChart
              :nightMode="nightMode"
              :data="emptyLine"
              style="padding: 10px"
            />
          </div>
          <div
            v-if="this.graphs.some((item) => item.influxId === 'PM2_5')"
            class="section-content-donuts"
          >
            <LineChart
              :nightMode="nightMode"
              :data="
                this.graphs.filter(
                  (graph) => graph.influxId == 'PM2_5' && graph.type == 'line'
                )[0]
              "
              style="padding: 10px"
            />
          </div>
          <div
            v-if="this.graphs.some((item) => item.influxId === 'PM10')"
            class="section-content-donuts"
          >
            <LineChart
              :nightMode="nightMode"
              :data="
                this.graphs.filter(
                  (graph) => graph.influxId == 'PM10' && graph.type == 'line'
                )[0]
              "
              style="padding: 10px"
            />
          </div>
          <div
            v-if="this.graphs.some((item) => item.influxId === 'NO2')"
            class="section-content-donuts"
          >
            <LineChart
              :nightMode="nightMode"
              :data="
                this.graphs.filter(
                  (graph) => graph.influxId == 'NO2' && graph.type == 'line'
                )[0]
              "
              style="padding: 10px"
            />
          </div>
          <div
            v-if="this.graphs.some((item) => item.influxId === 'SO2')"
            class="section-content-donuts"
          >
            <LineChart
              :nightMode="nightMode"
              :data="
                this.graphs.filter(
                  (graph) => graph.influxId == 'SO2' && graph.type == 'line'
                )[0]
              "
              style="padding: 10px"
            />
          </div>
          <div
            v-if="this.graphs.some((item) => item.influxId === 'O3')"
            class="section-content-donuts"
          >
            <LineChart
              :nightMode="nightMode"
              :data="
                this.graphs.filter(
                  (graph) => graph.influxId == 'O3' && graph.type == 'line'
                )[0]
              "
              style="padding: 10px"
            />
          </div>
          <div
            v-if="this.graphs.some((item) => item.influxId === 'noise')"
            class="section-content-donuts"
          >
            <LineChart
              :nightMode="nightMode"
              :data="
                this.graphs.filter(
                  (graph) => graph.influxId == 'noise' && graph.type == 'line'
                )[0]
              "
              style="padding: 10px"
            />
          </div>
          <div
            v-if="this.graphs.some((item) => item.influxId === 'CO2')"
            class="section-content-donuts"
          >
            <LineChart
              :nightMode="nightMode"
              :data="
                this.graphs.filter(
                  (graph) => graph.influxId == 'CO2' && graph.type == 'line'
                )[0]
              "
              style="padding: 10px"
            />
          </div>
          <div
            v-if="this.graphs.some((item) => item.influxId === 'T')"
            class="section-content-donuts"
          >
            <LineChart
              :nightMode="nightMode"
              :data="
                this.graphs.filter(
                  (graph) => graph.influxId == 'T' && graph.type == 'line'
                )[0]
              "
              style="padding: 10px"
            />
          </div>
          <div
            v-if="this.graphs.some((item) => item.influxId === 'RH')"
            class="section-content-donuts"
          >
            <LineChart
              :nightMode="nightMode"
              :data="
                this.graphs.filter(
                  (graph) => graph.influxId == 'RH' && graph.type == 'line'
                )[0]
              "
              style="padding: 10px"
            />
          </div>
          <div
            v-if="this.graphs.some((item) => item.name === 'I_BATT_000')"
            class="section-content-donuts"
          >
            <LineChart
              :nightMode="nightMode"
              :data="
                this.graphs.filter(
                  (graph) => graph.name == 'I_BATT_000' && graph.type == 'line'
                )[0]
              "
              style="padding: 10px"
            />
          </div>
          <div
            v-if="this.graphs.some((item) => item.name === 'PWM_Led_000')"
            class="section-content-donuts"
          >
            <LineChart
              :nightMode="nightMode"
              :data="
                this.graphs.filter(
                  (graph) => graph.name == 'PWM_Led_000' && graph.type == 'line'
                )[0]
              "
              style="padding: 10px"
            />
          </div>
          <div
            v-if="this.graphs.some((item) => item.name === 'SoC_000')"
            class="section-content-donuts"
          >
            <LineChart
              :nightMode="nightMode"
              :data="
                this.graphs.filter(
                  (graph) => graph.name == 'SoC_000' && graph.type == 'line'
                )[0]
              "
              style="padding: 10px"
            />
          </div>
        </div>
        <hr
          :style="{
            'border-color': !nightMode ? '#fff' : '#000',
          }"
        />
      </div>
      <div v-if="!isSensorDataEmpty(3)">
        <div class="section-header text-center">
          <br />
          <div class="text-center text-2xl mb-4">
            {{ $t("dashboard_section4_title") }}
          </div>
        </div>
        <div class="grid grid-cols-1 lg:grid-cols-3">
          <div
            v-if="this.graphs.some((item) => item.name === 'I_BATT_000')"
            class="section-content-donuts"
          >
            <dashboard-donut
              v-for="donut in this.graphs.filter(
                (graph) => graph.name == 'I_BATT_000' && graph.type == 'donut'
              )"
              v-bind:key="donut.index"
              v-bind:donut="donut"
              v-bind:nightMode="nightMode"
            />
          </div>
          <div
            v-if="this.graphs.some((item) => item.name === 'PWM_Led_000')"
            class="section-content-donuts"
          >
            <dashboard-donut
              v-for="donut in this.graphs.filter(
                (graph) => graph.name == 'PWM_Led_000' && graph.type == 'donut'
              )"
              v-bind:key="donut.index"
              v-bind:donut="donut"
              v-bind:nightMode="nightMode"
            />
          </div>
          <div
            v-if="this.graphs.some((item) => item.name === 'SoC_000')"
            class="section-content-donuts"
          >
            <dashboard-donut
              v-for="donut in this.graphs.filter(
                (graph) => graph.name == 'SoC_000' && graph.type == 'donut'
              )"
              v-bind:key="donut.index"
              v-bind:donut="donut"
              v-bind:nightMode="nightMode"
            />
          </div>
        </div>
      </div>
      <br /><br />
    </div>
    <div v-else style="text-align: center">
      <br /><br /><br />
      <FacebookLoader
        :color="this.nightMode === true ? '#000000' : '#ffffff'"
        :size="34"
      />
    </div>
  </div>
</template>

<script>
    /**
    * Vista de dashboard donde mostramos los gráficos de los sensores del solarhub del cluster seleccionado.
    * Las gráficas pueden ser de línea,  o de donut
    * Se separa el AQI del resto de sensores porque requiere más tiempo de carga.
    */
import LineChart from "../components/charts/LineChart.vue";
import DashboardDonut from "../components/charts/DashboardDonut.vue";
import AQIDashboardDonut from "../components/charts/AQIDashboardDonut.vue";

import { getDashboard, getSensorAQI } from "@/utils/SolarHubService.js";
import { FacebookLoader } from "vue-spinners-css";

import { mapState } from "vuex";

export default {
  name: "App",
  components: {
    LineChart,
    DashboardDonut,
    AQIDashboardDonut,
    FacebookLoader
  },
  props: ["nightMode", "selectedHub"],
  data() {
    return {
      aqiSensor: {},
      graphs: {},
      filterLineData: [],
      filterPieData: [],
      sectionFirst: [],
      emptyDonut: {
        name: "AQI",
        type: "donut",
        influxId: "AQI"
      },
      emptyLine: {
        name: "AQI",
        type: "line",
        influxId: "AQI",
        sensorData: [],
        units: ""
      }
    };
  },
    /**
    * Carga los gráficos y el gráfico AQI aparte(como el aqi tarda más en llegar, se separa para que cuando cargue se muestre después)
    */
  async beforeMount() {
    this.loadGraphs();
    this.loadAQI();
  },
  methods: {
    /**
    * Método que obtiene los datos de los gráficos para envíarlos a los componentes y dibujarlos. Antes de envíarlo se filtran y se separan según el tipo
    */
    async loadGraphs() {
      this.graphs = {};
      this.filterLineData = [];
      this.filterPieData = [];
      this.sectionFirst = [];
      this.graphs = await getDashboard(
        this.currentCluster[0].id,
        this.currentCluster[0].solarHubs[this.selectedHub].id
      );
      this.graphs.forEach(element => {
        if (element.type === "line" && element.name !== "I_BATT_000") {
          if (element.name == "AQI") {
            element.sensorData = [...element.sensorData].reverse();
          }
          this.filterLineData.push(element);
        }
      });
      this.sectionFirst = this.graphs.filter(
        graph => graph.name == "AQI" && graph.type == "donut"
      );
      this.graphs.forEach(element => {
        if (
          (element.type === "donut" && element.name === "I_BATT_000") ||
          element.name === "PWM_Led_000" ||
          element.name === "SoC_000"
        ) {
          this.filterPieData.push(element);
        }
      });
    },
    /**
    * Método para obtener los datos del sensor AQI
    */
    async loadAQI() {
      this.aqiSensor = await getSensorAQI(
        this.currentCluster[0].id,
        this.currentCluster[0].solarHubs[this.selectedHub].id
      );
    },

    /**
    * Método que detecta si un sensor de la sección está vacio.
    */
    isSensorDataEmpty(section) {
      switch (section) {
        case 1:
          return this.isEmpty(this.graphs, []);
        case 2:
          return this.isEmpty(this.graphs, ["noise", "CO2", "T", "RH"]);
        case 3:
          return this.isSpecialSensorEmpty(this.graphs, [
            "I_BATT_000",
            "PWM_Led_000",
            "SoC_000"
          ]);
        case 4:
          return this.graphs
            .filter(
              g =>
                g.influxId !== "AQI" &&
                g.influxId !== "T" &&
                g.influxId !== "RH" &&
                g.influxId !== "CO2" &&
                g.influxId !== "noise" &&
                g.name !== "I_BATT_000" &&
                g.name !== "PWM_Led_000" &&
                g.name !== "SoC_000"
            )
            .every(g => g.sensorData === null);
        case 5:
          return (
            this.graphs.filter(
              g =>
                (g.influxId == "NO2" && g.type == "donut") ||
                (g.influxId == "SO2" && g.type == "donut") ||
                (g.influxId == "O3" && g.type == "donut") ||
                (g.influxId == "PM2_5" && g.type == "donut") ||
                (g.influxId == "PM10" && g.type == "donut")
            ).length == 5
          );
      }
      return isEmpty;
    },
    /**
    * Método que la lista de datos de los gráficos y los nombres comparándolos por el influxId para poder detectar si está vacío la sección.
    */
    isEmpty(graphData, names) {
      if (names.length === 0) {
        return graphData
          .filter(
            g =>
              g.influxId !== "AQI" &&
              g.influxId !== "T" &&
              g.influxId !== "RH" &&
              g.influxId !== "CO2" &&
              g.influxId !== "noise"
          )
          .every(g => g.sensorData === null);
      } else {
        return graphData
          .filter(g => names.includes(g.influxId))
          .every(g => g.sensorData === null);
      }
    },
    /**
    * Método que la lista de datos de los gráficos y los nombres comparándolos por el name para poder detectar si está vacío la sección.
    */
    isSpecialSensorEmpty(graphData, names) {
      return graphData
        .filter(g => names.includes(g.name))
        .every(g => g.sensorData === null);
    }
  },
  computed: {
    ...mapState("clusters", ["currentCluster"]),
    ...mapState("sensors", ["limits"])
  },
  watch: {
    /**
    * Detecta sí hay cambios en el modo noche, cluster seleccionado o solarhub seleccionado, recargando la lista de gráficos y aqi.
    * En este caso se recarga la página para que se actualicen los estilos de las gráficas.
    */
    nightMode: function() {
      window.location.reload();
    },
    currentCluster: function() {
      this.aqiSensor = {};
      this.loadGraphs();
      this.loadAQI();
    },
    selectedHub: function() {
      this.aqiSensor = {};
      this.loadGraphs();
      this.loadAQI();
    }
  }
};
</script>

<style >
.vue-gauge-item svg {
  margin: 0 auto;
}

.custom-gauge-dark {
  fill: white;
}
.custom-gauge {
  fill: black;
}
.tooltip {
  display: block !important;
  z-index: 10000;
}

.tooltip .tooltip-inner {
  background: #2d2d2d;

  color: white;
  border-radius: 2px;
}

.tooltip .tooltip-arrow {
  width: 0;
  height: 0;
  border-style: solid;
  position: absolute;
  margin: 5px;
  border-color: transparent;
  z-index: 1;
}

.tooltip[x-placement^="top"] {
  margin-bottom: 5px;
}

.tooltip[x-placement^="top"] .tooltip-arrow {
  border-width: 5px 5px 0 5px;
  border-left-color: transparent !important;
  border-right-color: transparent !important;
  border-bottom-color: transparent !important;
  bottom: -5px;
  left: calc(50% - 5px);
  margin-top: 0;
  margin-bottom: 0;
}

.tooltip[x-placement^="bottom"] {
  margin-top: 5px;
}

.tooltip[x-placement^="bottom"] .tooltip-arrow {
  border-width: 0 5px 5px 5px;
  border-left-color: transparent !important;
  border-right-color: transparent !important;
  border-top-color: transparent !important;
  top: -5px;
  left: calc(50% - 5px);
  margin-top: 0;
  margin-bottom: 0;
}

.tooltip[x-placement^="right"] {
  margin-left: 5px;
}

.tooltip[x-placement^="right"] .tooltip-arrow {
  border-width: 5px 5px 5px 0;
  border-left-color: transparent !important;
  border-top-color: transparent !important;
  border-bottom-color: transparent !important;
  left: -5px;
  top: calc(50% - 5px);
  margin-left: 0;
  margin-right: 0;
}

.tooltip[x-placement^="left"] {
  margin-right: 5px;
}

.tooltip[x-placement^="left"] .tooltip-arrow {
  border-width: 5px 0 5px 5px;
  border-top-color: transparent !important;
  border-right-color: transparent !important;
  border-bottom-color: transparent !important;
  right: -5px;
  top: calc(50% - 5px);
  margin-left: 0;
  margin-right: 0;
}

.tooltip.popover .popover-inner {
  color: black;
  border-radius: 5px;
  box-shadow: 0 5px 30px rgba(black, 0.1);
}

.tooltip.popover .popover-arrow {
  border-color: #f9f9f9;
}

.tooltip[aria-hidden="true"] {
  visibility: hidden;
  opacity: 0;
  transition: opacity 0.15s, visibility 0.15s;
}

.tooltip[aria-hidden="false"] {
  visibility: visible;
  opacity: 1;
  transition: opacity 0.15s;
}
</style>